import { useEffect, useRef } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
const Header = () => {
  const headerRef = useRef(null);
  const location = useLocation();
  useEffect(() => {
    if (headerRef.current) {
      window.$(headerRef.current).themePluginSticky({
        stickyEnabled: true,
        stickyEffect: 'shrink',
        stickyEnableOnBoxed: true,
        stickyEnableOnMobile: false,
        stickyChangeLogo: false,
        stickyStartAt: 1,
        stickyHeaderContainerHeight: 100
      });
    }
  }, []);
  return (
    <header id="header" className="header-transparent header-effect-shrink">
      <div className="header-body border-top-0 bg-color-dark box-shadow-none" ref={headerRef}>
        <div className="header-container container">
          <div className="header-row">
            {/* Logo Section */}
            <div className="header-column header-column-logo">
              <div className="header-row">
                <div className="header-logo">
                  <NavLink to="/">
                    <img alt="Porto" height="60" src="img/mine/Gunadhya AI Logo.gif" />
                  </NavLink>
                </div>
              </div>
            </div>

            {/* Navigation Menu */}
            <div className="header-column header-column-nav-menu justify-content-end w-100">
              <div className="header-row">
                <div className="header-nav header-nav-links header-nav-dropdowns-dark header-nav-light-text order-2 order-lg-1">
                  <div className="header-nav-main header-nav-main-mobile-dark header-nav-main-square header-nav-main-dropdown-no-borders header-nav-main-effect-2 header-nav-main-sub-effect-1">
                    <nav className="collapse">
                      {/* <ul className="nav nav-pills" id="mainNav">
                        <li className="dropdown-primary">
                          <NavLink
                            className={`nav-link text-capitalize font-weight-semibold custom-text-3 `}
                            to="/"
                            style={location.pathname === '/' ? { color: '#2ce1ff' } : {}}
                          >
                            Home
                          </NavLink>
                        </li>
                        <li className="dropdown-primary">
                          <NavLink
                            className={`nav-link text-capitalize font-weight-semibold custom-text-3 `}
                            to="/about-us"
                            style={location.pathname === '/about-us' ? { color: '#2ce1ff' } : {}}
                          >
                            About Us
                          </NavLink>
                        </li> 
                        <li className="dropdown-primary">
                          <NavLink
                            className={`nav-link text-capitalize font-weight-semibold custom-text-3 `}
                            style={location.pathname === '/our-utilities' ? { color: '#2ce1ff' } : {}}
                            to="/our-utilities"
                          >
                            Our Utilities
                          </NavLink>
                        </li>
                        <li className="dropdown-primary">
                          <NavLink
                            className={`nav-link text-capitalize font-weight-semibold custom-text-3 `}
                            style={location.pathname === '/our-insight' ? { color: '#2ce1ff' } : {}}
                            to="/our-insight"
                          >
                            Our Insights
                          </NavLink>
                        </li>
                        <li className="dropdown-primary">
                          <NavLink
                            className={`nav-link text-capitalize font-weight-semibold custom-text-3 `}
                            style={location.pathname === '/contact-us' ? { color: '#2ce1ff' } : {}}
                            to="/contact-us"
                          >
                            Contact Us
                          </NavLink>
                        </li>
                      </ul> */}
                    </nav>
                  </div>
                  <button className="btn header-btn-collapse-nav" data-bs-toggle="collapse" data-bs-target=".header-nav-main nav">
                    <i className="fas fa-bars"></i>
                  </button>
                </div>
              </div>
            </div>

            {/* Social Media Icons */}
            <div className="header-column justify-content-end d-none d-lg-flex">
              <div className="header-row">
                <ul className="header-social-icons social-icons social-icons-clean social-icons-icon-light social-icons-big d-lg-flex m-0 ms-lg-2">
                  <li className="social-icons-instagram">
                    <NavLink
                      to="https://www.instagram.com/gunadhyasoft"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-4"
                      title="Instagram"
                    >
                      <i className="fab fa-instagram"></i>
                    </NavLink>
                  </li>
                  <li className="social-icons-linkedin">
                    <NavLink
                      to="https://www.linkedin.com/company/gunadhya-software-solutions-pvt--ltd-/posts/?feedView=all"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-4"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in"></i>
                    </NavLink>
                  </li>

                  <li className="social-icons-facebook">
                    <NavLink
                      to="https://www.facebook.com/gunadhyasoft"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-4"
                      title="Facebook"
                    >
                      <i className="fab fa-facebook-f"></i>
                    </NavLink>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
